import React, { useRef, useState, useEffect } from "react";
import NavBar from "../NavBar/NavBar.tsx";
import Help from "../Help Section/Help";
import Footer from "../Footer/Footer.tsx";
import { useHistory } from "react-router-dom";
import { aboutUsImg1, aboutUsImg3, webDevelopImg2, OurClient } from "../../Assets.tsx";
import ScrollToTopButton from "../Common-component/ScrollToTopButton.tsx";

/* Colours: text #4e5356 | buttons #2596be | headings #4573a6 | background white
   Fonts  : Ubuntu Bold (headings) / Open Sans Regular (body) */

const stats = [
  { n: "700+", t: "Successful Apps" },
  { n: "100+", t: "Mobile Solutions" },
  { n: "9+", t: "Years Experience" },
  { n: "40+", t: "Industries Served" },
];

const steps = [
  { t: "Assess", d: "We start by assessing your current systems and identifying opportunities for growth." },
  { t: "Design", d: "We design custom IT strategies that align with your specific goals." },
  { t: "Transform", d: "We bridge today's challenges and future aspirations with proven technologies." },
];

const industries = [
  "E-Commerce", "Healthcare", "Retail", "Travel & Tourism", "Taxi Booking",
  "Food Delivery", "Energy & Utilities", "Highway Management", "Financial Services", "Education",
];

const STYLES = `
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600&family=Ubuntu:wght@700&display=swap");

.ab{--text:#4e5356;--head:#4573a6;--btn:#2596be;--tint:#eef6fa;--line:#d3e4ed;
  position:relative;overflow:hidden;background:#fff;font-family:"Open Sans",sans-serif;font-weight:400;color:var(--text)}
.ab-in{display:flex;align-items:center;justify-content:space-between;gap:70px;max-width:1240px;margin:0 auto}
.ab-in.rev{flex-direction:row-reverse}
.ab-sec{padding:70px 24px}
.ab-center{text-align:center;max-width:860px;margin:0 auto}

.ab-chip{display:inline-block;margin-bottom:16px;padding:6px 18px;border-radius:50px;background:var(--tint);border:1px solid var(--line);
  color:var(--head);font-size:12px;letter-spacing:2px;text-transform:uppercase}
.ab h1,.ab h2{margin:0 0 16px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:42px;line-height:1.15;color:var(--head);cursor:default;transition:color .35s,letter-spacing .35s}
.ab h1:hover,.ab h2:hover{color:var(--btn);letter-spacing:.6px}
.ab-sec h2{font-size:36px}
.ab-line{display:flex;align-items:center;gap:12px;margin-bottom:20px}
.ab-center .ab-line{justify-content:center}
.ab-line i{display:block;height:2px;width:40px;border-radius:2px;background:var(--btn)}.ab-line i:last-child{background:var(--head)}
.ab p{margin:0 0 16px;font-size:14.5px;line-height:1.75;color:var(--text)}
.ab p b{font-family:"Ubuntu",sans-serif;font-weight:700;color:var(--head)}
.ab-text{flex:1;min-width:0;max-width:580px}

/* scroll reveal */
.rv{opacity:0;transform:translateY(46px);transition:opacity .8s cubic-bezier(.2,.8,.2,1),transform .8s cubic-bezier(.2,.8,.2,1);transition-delay:var(--d,0s)}
.rv.in{opacity:1;transform:none}

/* button = same as .op-btn */
.ab-btn{position:relative;overflow:hidden;z-index:0;display:inline-flex;align-items:center;gap:8px;padding:12px 28px;border:none;border-radius:50px;
  background:var(--tint);color:var(--head);font-family:"Open Sans",sans-serif;font-weight:600;font-size:14px;cursor:pointer;box-shadow:0 0 0 1px var(--line) inset;
  transition:color .35s,transform .35s cubic-bezier(.3,1.6,.5,1),box-shadow .35s}
.ab-btn::before{content:"";position:absolute;inset:0;z-index:-1;background:linear-gradient(90deg,var(--head),var(--btn));transform:translateX(-101%);transition:transform .45s cubic-bezier(.2,.8,.2,1)}
.ab-btn:hover{color:#fff;transform:translateY(-3px);box-shadow:0 16px 26px -12px rgba(37,150,190,.7)}
.ab-btn:hover::before{transform:none}
.ab-btn span{display:inline-block;transition:transform .35s}
.ab-btn:hover span{transform:translateX(5px)}

/* hero */
.ab-hero{padding:150px 24px 80px}
.ab-hero .ab-text{animation:abL .9s cubic-bezier(.2,.8,.2,1) backwards}
.ab-vis{position:relative;flex:none;width:46%;max-width:540px}
.ab-hero .ab-vis{animation:abR .9s .15s cubic-bezier(.2,.8,.2,1) backwards}
.ab-ring{position:absolute;inset:-14px;border-radius:44px;overflow:hidden}
.ab-ring::before{content:"";position:absolute;left:50%;top:50%;width:200%;height:200%;margin:-100% 0 0 -100%;
  background:conic-gradient(from 0deg,#4573a6,#2596be,#a9d3e6,#4573a6);animation:abSpin 8s linear infinite}
.ab-ring::after{content:"";position:absolute;inset:4px;border-radius:40px;background:#fff}
.ab-tilt{position:relative;padding:28px;border-radius:32px;background:#fff;border:1px solid var(--line);box-shadow:0 30px 50px -26px rgba(69,115,166,.5);
  transition:transform .15s ease-out;transform:perspective(900px) rotateX(0) rotateY(0)}
.ab-tilt img{display:block;width:100%;height:auto;object-fit:contain}
.ab-chipf{position:absolute;z-index:3;display:flex;align-items:center;gap:10px;padding:10px 16px;border-radius:16px;background:#fff;
  border:1px solid var(--line);box-shadow:0 18px 30px -16px rgba(69,115,166,.55);font-size:13px;color:var(--text);white-space:nowrap}
.ab-chipf b{display:block;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:15px;color:var(--head)}
.ab-chipf .dot{width:34px;height:34px;border-radius:10px;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;background:linear-gradient(135deg,var(--head),var(--btn))}
.ab-chipf.c1{left:-34px;bottom:44px;animation:abFloat 5s ease-in-out infinite}
.ab-chipf.c2{right:-24px;top:34px;animation:abFloat 6s -2s ease-in-out infinite}

/* image card with offset tint */
.ab-img{position:relative;flex:none;width:44%;max-width:500px}
.ab-img::before{content:"";position:absolute;inset:-18px 18px 18px -18px;border-radius:32px;background:var(--tint);border:1px solid var(--line)}
.ab-in.rev .ab-img::before{inset:-18px -18px 18px 18px}
.ab-img img{position:relative;display:block;width:100%;height:auto;object-fit:contain;padding:22px;border-radius:32px;background:#fff;border:1px solid var(--line);
  box-shadow:0 30px 50px -26px rgba(69,115,166,.5);transition:transform .5s cubic-bezier(.3,1.4,.5,1)}
.ab-img:hover img{transform:translateY(-8px)}

/* cards (stats, steps, industries) */
.ab-card{position:relative;overflow:hidden;background:#fff;border:1px solid var(--line);border-radius:24px;box-shadow:0 18px 36px -26px rgba(69,115,166,.55);
  transition:transform .4s cubic-bezier(.3,1.4,.5,1),box-shadow .4s,border-color .4s}
.ab-card::before{content:"";position:absolute;top:0;left:0;width:100%;height:5px;transform:scaleX(0);transform-origin:left;background:linear-gradient(90deg,var(--head),var(--btn));transition:transform .55s cubic-bezier(.2,.8,.2,1)}
.ab-card:hover{transform:translateY(-8px);border-color:rgba(37,150,190,.5);box-shadow:0 30px 50px -22px rgba(37,150,190,.6)}
.ab-card:hover::before{transform:scaleX(1)}

.ab-stats{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:22px;max-width:1000px;margin:50px auto 0}
.ab-stat{padding:28px 18px;text-align:center}
.ab-stat strong{display:block;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:34px;line-height:1.1;color:var(--head);transition:color .35s}
.ab-stat:hover strong{color:var(--btn)}
.ab-stat span{display:block;margin-top:6px;font-size:14.5px;color:var(--text)}

.ab-steps{display:grid;grid-template-columns:1fr;gap:14px;margin-top:22px}
.ab-step{display:flex;align-items:center;gap:16px;padding:16px 18px;border-radius:20px}
.ab-step em{flex:none;width:40px;height:40px;border-radius:12px;display:flex;align-items:center;justify-content:center;font-style:normal;
  font-family:"Ubuntu",sans-serif;font-weight:700;font-size:16px;color:#fff;background:linear-gradient(135deg,var(--head),var(--btn))}
.ab-step h3{margin:0 0 2px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:20px;letter-spacing:.6px;color:var(--head)}
.ab-step p{margin:0;font-size:14.5px;line-height:1.6}

.ab-tags{display:flex;flex-wrap:wrap;gap:10px;margin-top:6px}
.ab-tag{position:relative;overflow:hidden;z-index:0;padding:7px 18px;border-radius:50px;background:var(--tint);border:1px solid var(--line);color:var(--head);
  font-size:14px;font-weight:600;cursor:default;transition:color .35s,border-color .35s,transform .35s cubic-bezier(.3,1.6,.5,1)}
.ab-tag::before{content:"";position:absolute;inset:0;z-index:-1;background:linear-gradient(90deg,var(--head),var(--btn));transform:translateY(101%);transition:transform .4s cubic-bezier(.2,.8,.2,1)}
.ab-tag:hover{color:#fff;border-color:transparent;transform:translateY(-3px)}
.ab-tag:hover::before{transform:none}

.ab-ind{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:18px;max-width:1240px;margin:44px auto 0}
.ab-indc{padding:26px 14px;text-align:center}
.ab-indc i{display:flex;align-items:center;justify-content:center;width:46px;height:46px;margin:0 auto 14px;border-radius:14px;font-style:normal;
  font-family:"Ubuntu",sans-serif;font-weight:700;font-size:16px;color:var(--head);background:var(--tint);transition:background .4s,color .4s,transform .5s cubic-bezier(.3,1.4,.5,1)}
.ab-indc:hover i{background:linear-gradient(135deg,var(--head),var(--btn));color:#fff;transform:translateY(-4px)}
.ab-indc h3{margin:0;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:16px;letter-spacing:.4px;color:var(--head)}

/* closing band */
.ab-cta{display:flex;align-items:center;justify-content:space-between;gap:24px;flex-wrap:wrap;max-width:1240px;margin:0 auto;padding:40px 44px;border-radius:28px;
  position:relative;overflow:hidden;color:#fff;background:linear-gradient(120deg,var(--head),var(--btn));box-shadow:0 30px 60px -34px rgba(37,150,190,.8)}
.ab-cta h2,.ab-cta h2:hover{margin:0 0 8px;font-size:28px;letter-spacing:.6px;color:#fff}
.ab p.ab-ctap{margin:0;color:rgba(255,255,255,.9);max-width:620px}
.ab-cta .ab-btn{background:#fff}

@keyframes abL{from{opacity:0;transform:translateX(-70px)}}
@keyframes abR{from{opacity:0;transform:translateX(70px)}}
@keyframes abSpin{to{transform:rotate(360deg)}}
@keyframes abFloat{50%{transform:translateY(-12px)}}

@media(max-width:1100px){.ab-ind{grid-template-columns:repeat(3,minmax(0,1fr))}}
@media(max-width:960px){
  .ab-hero{padding:120px 18px 60px}
  .ab-in,.ab-in.rev{flex-direction:column;gap:56px}
  .ab-text{max-width:100%}
  .ab-vis,.ab-img{width:100%;max-width:420px}
  .ab-chipf.c1{left:-8px}.ab-chipf.c2{right:-8px}
  .ab-sec{padding:50px 18px}
  .ab-stats{grid-template-columns:repeat(2,minmax(0,1fr))}
}
@media(max-width:600px){
  .ab h1{font-size:30px}.ab-sec h2{font-size:28px}
  .ab-ind{grid-template-columns:repeat(2,minmax(0,1fr))}
  .ab-cta{padding:30px 22px}.ab-cta h2{font-size:22px}
}
@media(prefers-reduced-motion:reduce){
  .ab *,.ab *::before,.ab *::after{animation:none!important;transition:none!important}
  .rv{opacity:1;transform:none}
}
`;

/* fades a block in once it scrolls into view */
const Reveal = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div ref={ref} className={"rv " + className + (show ? " in" : "")} style={{ "--d": delay + "s" }}>
      {children}
    </div>
  );
};

const AboutUsPage = () => {
  const history = useHistory();
  const tiltRef = useRef(null);

  // gentle 3D tilt on the hero image
  const handleMove = (e) => {
    const el = tiltRef.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const ry = ((e.clientX - r.left) / r.width - 0.5) * 10;
    const rx = ((e.clientY - r.top) / r.height - 0.5) * -10;
    el.style.transform = `perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg)`;
  };
  const handleLeave = () => {
    if (tiltRef.current) tiltRef.current.style.transform = "perspective(900px) rotateX(0deg) rotateY(0deg)";
  };

  return (
    <div>
      <NavBar />
      <style>{STYLES}</style>

      <div className="ab">
        {/* HERO */}
        <div className="ab-hero">
          <div className="ab-in">
            <div className="ab-text">
              <div className="ab-chip">About Us</div>
              <h1>The Vision Behind Our Online Presence</h1>
              <div className="ab-line"><i /><i /></div>
              <p>
                At <b>ATUM Information Technologies</b>, our online presence reflects our commitment to delivering
                cutting-edge IT solutions and fostering innovation. The digital landscape is ever-evolving, and so
                are we. Our vision is to empower businesses by providing them with scalable, secure, and efficient
                technology solutions that drive growth and operational excellence.
              </p>
              <button className="ab-btn" onClick={() => history.push("/contact")}>
                Get Started <span>→</span>
              </button>
            </div>

            <div className="ab-vis" onMouseMove={handleMove} onMouseLeave={handleLeave}>
              <div className="ab-ring" />
              <div className="ab-tilt" ref={tiltRef}>
                <img src={aboutUsImg1} alt="About ATUM" />
              </div>
              <div className="ab-chipf c1">
                <span className="dot">✓</span>
                <div>Scalable<b>& Secure</b></div>
              </div>
              <div className="ab-chipf c2">
                <span className="dot">★</span>
                <div>Driving<b>Growth</b></div>
              </div>
            </div>
          </div>
        </div>

        {/* VISION */}
        <div className="ab-sec">
          <Reveal className="ab-center">
            <div className="ab-chip">Our Vision</div>
            <h2>Vision Of Company</h2>
            <div className="ab-line"><i /><i /></div>
            <p>
              Through our website, we aim to connect with forward-thinking organisations and individuals who are
              looking for more than just technology service, they are seeking trusted partnerships. By showcasing
              our expertise, range of services, and client success stories, we want to build lasting relationships
              and establish ourselves as leaders in the IT industry.
            </p>
            <p>
              Our online presence is more than just a platform for information; it’s a hub for collaboration,
              where businesses can find the tools, resources, and knowledge to unlock their full potential. We
              believe in leveraging technology to create meaningful and impactful solutions that shape the future.
              Whether you're here to explore our services, learn more about the latest trends in IT, or connect
              with our team, our goal is to ensure that your journey with us is seamless and valuable.
            </p>
            <p>
              As technology continues to evolve, so does our dedication to providing innovative, reliable, and
              sustainable IT solutions that align with your business needs. We invite you to explore our site,
              engage with our content, and discover how we can help your business thrive in the digital age.
            </p>
          </Reveal>
        </div>

        {/* ABOUT OUR CLIENT */}
        <div className="ab-sec">
          <div className="ab-in">
            <Reveal className="ab-img">
              <img src={OurClient} alt="About our client" />
            </Reveal>
            <Reveal className="ab-text" delay={0.12}>
              <div className="ab-chip">Our Experience</div>
              <h2>About Our Client</h2>
              <div className="ab-line"><i /><i /></div>
              <p>
                When it comes to mobile development, no one does it better than <b>ATUM Information Technology</b>.
                With more than 9 years of experience, we provide services from mobile app development to web design
                and development.
              </p>
              <p>
                We have developed over 700 successful apps and more than 100 mobile application solutions, and we
                have worked with over 40 industries, providing A-1 service to each client’s requirements. When we
                set out on a client’s project, we do not treat it as just one of many; we take it personally and
                give it our utmost expertise. This is where we stand out.
              </p>
            </Reveal>
          </div>

          <div className="ab-stats">
            {stats.map((s, i) => (
              <Reveal key={s.t} delay={i * 0.1}>
                <div className="ab-card ab-stat">
                  <strong>{s.n}</strong>
                  <span>{s.t}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        {/* FROM WHERE TO WHERE */}
        <div className="ab-sec">
          <div className="ab-in rev">
            <Reveal className="ab-img">
              <img src={aboutUsImg3} alt="From where to where" />
            </Reveal>
            <Reveal className="ab-text" delay={0.12}>
              <div className="ab-chip">Our Approach</div>
              <h2>From Where To Where</h2>
              <div className="ab-line"><i /><i /></div>
              <p>
                We understand that every business is on a unique journey. Our role is to guide you from where you
                are today to where you envision your business tomorrow. Whether you're looking to streamline
                operations, enhance digital capabilities, or integrate the latest technological solutions, we are
                here to support your transformation every step of the way.
              </p>
              <p>
                Through our expertise and commitment, we help you navigate the complexities of the digital
                landscape, ensuring that your technology infrastructure evolves seamlessly to meet the demands of
                tomorrow’s business world.
              </p>
              <div className="ab-steps">
                {steps.map((s, i) => (
                  <div className="ab-card ab-step" key={s.t}>
                    <em>{i + 1}</em>
                    <div>
                      <h3>{s.t}</h3>
                      <p>{s.d}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>

        {/* WORK CULTURE */}
        <div className="ab-sec">
          <div className="ab-in">
            <Reveal className="ab-text">
              <div className="ab-chip">Our People</div>
              <h2>Our Work Culture</h2>
              <div className="ab-line"><i /><i /></div>
              <p>
                At ATUM Information Technologies, we believe that a positive and supportive work environment is key
                to both employee satisfaction and business success. We foster a culture where our team members feel
                valued, respected, and empowered. By creating a workplace that caters to the needs of every
                individual, we inspire our employees to give their best effort in everything they do.
              </p>
              <p>
                We recognise that our employees are the backbone of our business. Their contributions, creativity,
                and innovation are what drive us forward. This sense of inclusion and empowerment creates a work
                atmosphere where employees feel comfortable expressing themselves, leading to increased
                productivity and groundbreaking solutions.
              </p>
              <p>
                We encourage our team to push the boundaries of their skills and explore new ideas, because we
                believe innovation thrives in an environment that nurtures creativity and self-expression.
              </p>
              <div className="ab-tags">
                <span className="ab-tag">Valued</span>
                <span className="ab-tag">Respected</span>
                <span className="ab-tag">Empowered</span>
                <span className="ab-tag">Creative</span>
              </div>
            </Reveal>
            <Reveal className="ab-img" delay={0.12}>
              <img src={webDevelopImg2} alt="Our work culture" />
            </Reveal>
          </div>
        </div>

        {/* INDUSTRIES */}
        <div className="ab-sec">
          <Reveal className="ab-center">
            <div className="ab-chip">Who We Serve</div>
            <h2>Industries We Serve & Our Diverse Clientele</h2>
            <div className="ab-line"><i /><i /></div>
            <p>
              At ATUM Information Technologies, we specialise in delivering comprehensive IT solutions tailored to
              meet the unique needs of each industry we serve. From mobile app development to web design and
              development, we are your trusted partner in transforming ideas into reality. We proudly cater to a
              diverse range of sectors, including:
            </p>
          </Reveal>
          <div className="ab-ind">
            {industries.map((name, i) => (
              <Reveal key={name} delay={(i % 5) * 0.08}>
                <div className="ab-card ab-indc">
                  <i>{name.charAt(0)}</i>
                  <h3>{name}</h3>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="ab-sec" style={{ paddingBottom: 100 }}>
          <Reveal>
            <div className="ab-cta">
              <div>
                <h2>Ready to start your journey?</h2>
                <p className="ab-ctap">Let us help you bring your vision to life and thrive in the digital age.</p>
              </div>
              <button className="ab-btn" onClick={() => history.push("/contact")}>
                Contact Us <span>→</span>
              </button>
            </div>
          </Reveal>
        </div>
      </div>

      <Help />
      <ScrollToTopButton />
      <Footer />
    </div>
  );
};

export default AboutUsPage;